import { Component } from "@angular/core";
import { Subscription } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";

@Component({
  selector: "app-comparative-analysis-subheader",
  templateUrl: "./comparative-analysis-subheader.component.html",
  styleUrls: ["./comparative-analysis-subheader.component.scss"],
})
export class ComparativeAnalysisSubheaderComponent {
  headerTitle = "";
  comparativeAnalysisSubscriber: Subscription;

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.comparativeAnalysisSubscriber = this.store
      .select(stateGetter("comparativeAnalysis", "pageCompTitle"))
      .subscribe((data) => {
        if (data) {
          this.headerTitle = data;
        }
      });
  }
}
